import styled from 'styled-components'

export const BodyContainer = styled.div`
    background-color: clear;
    padding: 40px var(--ps-body);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    alignItems: flex-start;
    width: 100vw;
    height: 100%;
    box-sizing: border-box;
    overflow: scroll;
`